module.exports = __webpack_public_path__ + "img/photo2_1.758326d8.jpg";